import AuthUser from 'component/AuthUser';
import React from 'react';
import { Route, RouteChildrenProps } from 'react-router-dom';
import KeepAlive from 'react-activation';

interface RouteComponent extends RouteChildrenProps<any> {
  routes?: BaseRoute[]
}

export interface BaseRoute {
  routes?: BaseRoute[]
  component: React.ComponentType<RouteComponent> | React.ComponentType<any>
  path: string
  exact?: boolean;
  sensitive?: boolean;
  strict?: boolean;
  auth?: boolean;
  keepAlive?: boolean;
  // 使用keepAlive可能遇到的问题，特别是ref和Context需要注意
  // https://github.com/CJY0208/react-activation/blob/master/README_CN.md#breaking-change-由实现原理引发的额外问题
};
// refer: https://reactrouter.com/web/example/route-config
export default function RouteWithSubRoutes (route: BaseRoute) {
  return (
    <Route
      path={route.path}
      render={props => {
        // pass the sub-routes down to keep nesting
        if (route.auth) {
          return (
            <AuthUser>
              <route.component {...props} routes={route.routes} />
            </AuthUser>
          );
        }

        if (route.keepAlive) {
          return (
            <KeepAlive>
              <route.component {...props} routes={route.routes} />
            </KeepAlive>
          );
        }

        return <route.component {...props} routes={route.routes} />;
      }}
    />
  );
}
